export default __webpack_public_path__ + "static/media/Profile_Jason_Speech.d6caf98f.png";